import { object } from "yup"
import { password, email } from "@/core/validation"

export default object({
  email,
  password,
})
